<template>
  <div>
    <v-tabs background-color="transparent" color="#FCA326" class="pb-0 mb-0">
      <v-tab @click="tabClicked(0)">
        Heuristics
      </v-tab>
      <v-tab @click="tabClicked(1)">
        Options
      </v-tab>
      <v-tab @click="tabClicked(2)">
        Import .csv
      </v-tab>
    </v-tabs>

    <div>
      <Heuristic v-if="index == 0" :heuristics="object.heuristics" />
      <OptionsTable v-if="index == 1" :options="object.options" />
      <ImportCsvTable v-if="index == 2" :options="object.importCsv" />
    </div>
  </div>
</template>

<script>
import Heuristic from '@/components/molecules/HeuristicsTable'
import OptionsTable from '@/components/molecules/OptionsTable'
import ImportCsvTable from '@/components/molecules/ImportCsvTable'

export default {
  components: {
    Heuristic,
    OptionsTable,
    ImportCsvTable,
  },
  props: {
    type: {
      type: String,
      required: true,
    },

    object: {
      type: Object,
      default: () => { },
    },
  },
  data: () => ({
    index: 0,
  }),
  computed: {
    currentTest() {
      return this.$store.state.Tests.Test.testStructure
    },
  },
  methods: {
    tabClicked(index) {
      this.index = index
    },

  },
}
</script>
